import type {PublicMethodUtils} from '@wix/document-services-types'
import type {LocalesPublicAPI} from '@wix/document-services-public-types'
import {locales} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export function localesPublicAPI(publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<LocalesPublicAPI> {
    const {defineGetter} = publicMethodUtils

    return {
        methods: {
            locales: {
                list: defineGetter(locales.list),
                isMultilingualEnabled: defineGetter(locales.isMultilingualEnabled)
            }
        }
    }
}
